import React, { FC } from 'react';

import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Box, CssBaseline, ThemeProvider, Typography } from '@mui/material';

import PrimaryBtn from 'components/UI/Buttons';
import DefaultTheme from 'components/layout/themes/DefaultTheme';
import { NOTIFICATION_CARD_TOKENS as T } from 'components/notifications/card/notificationCardTokens';

const AppErrorFallback: FC = () => (
  <ThemeProvider theme={DefaultTheme}>
    <CssBaseline />
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        boxSizing: 'border-box',
        textAlign: 'center',
        color: 'text.secondary',
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          mb: 2.5,
          borderRadius: '50%',
          bgcolor: T.unreadBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <ErrorOutlineOutlinedIcon aria-hidden sx={{ fontSize: 28, color: 'azure.main', opacity: 0.5 }} />
      </Box>
      <Typography variant="body2" sx={{ color: 'grey.900', fontWeight: 700, lineHeight: 1.5 }}>
        Algo salió mal
      </Typography>
      <Typography variant="caption" sx={{ mt: 0.5, color: 'grey.400', fontWeight: 500 }}>
        Recarga la aplicación para volver a intentarlo
      </Typography>
      <PrimaryBtn onClick={() => window.location.reload()} sx={{ mt: 3 }}>
        Recargar
      </PrimaryBtn>
    </Box>
  </ThemeProvider>
);

export default AppErrorFallback;
